"use client"

import { useMemo } from "react"
import { createResolvedProductData } from "src/components/product-details/createResolvedProductData"
import { DetailProductData } from "src/data/product-details/types"
import { useSelectedVariationByProduct } from "./useSelectedVariation"

export function useResolvedProductData(product: DetailProductData) {
  const selectedVariation = useSelectedVariationByProduct(product)

  return useMemo(() => {
    return createResolvedProductData(product, selectedVariation)
  }, [product, selectedVariation])
}

export type ResolvedProductData = ReturnType<typeof useResolvedProductData>
